
import { useContext, useEffect, useState } from 'react';
import './RegisterFirstDataCollection.css';
import { LoadState, Location, UserType } from '../common/enums.mjs';
import { LocaleContext, LoginContext } from '../common/App';
import { DropdownMenu, ForwardsBackwardsBar, NavigateSmart, RadioCheckButton } from '../common/Common';
import { useIndexUpdate, useNavigateSmart } from '../common/hooks';
import { useSearchParams } from 'react-router-dom';
import { convertIsoToLocalIsoWithoutTimezone, get_translation_objects } from '../common/util';


export function RegisterFirstDataCollection(props) {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    const [userType, setUserType] = useState(UserType.NONE);

    useIndexUpdate(props.indexUpdate, locale);


    // FUNCTIONS:

    function handleForwards() {
        navigate("/register/account/");
    }

    function isForwardsPossible() {
        return props.registerInfo.userType && props.registerInfo.userType !== UserType.NONE &&
                props.registerInfo.location && props.registerInfo.location !== Location.NONE;
    }


    // RENDER:

    const [locationTransList, locationTransListInverse] = get_translation_objects("location_long", Location, locale);

    return (
        <div id="register_first_data_collection" className="side_padding bottom_padding">
            { login.loggedIn ?
                <NavigateSmart to="/dashboard/" />
            :
                null
            }


            <FamOrNanny userType={props.registerInfo.userType} onUserTypeChange={(type) => props.setRegisterInfo({...props.registerInfo, "userType": type})} />


            <div className="head which_location_head">{locale.msgs.WHICH_MN_LOCATION}</div>
            <div className="text which_location_descr">{locale.msgs.WHICH_MN_LOCATION_DESCR}</div>

            <DropdownMenu text={locale.msgs.MN_LOCATION} options={Object.values(locationTransList)}
                                        value={locationTransList[props.registerInfo.location]}
                                        onValueChange={(value) => {
                                            props.setRegisterInfo({...props.registerInfo, "location": locationTransListInverse[value]});
                                        }}
                                        onScroll={props.onScroll}
                                        textSearch={true}
                                        textSearchInstruction={locale.msgs.SEARCH_LOCATION_VIA_TEXT_INSTRUCTION}
                                        showPlaceholderIfNotEmpty={false}
            />


            <div id="forwards_backwards_bar_wrap_box" className="forwards_backwards_bar_wrap_box">
                <ForwardsBackwardsBar backwardsVisible={false} forwardsVisible={true}
                                backwardsClickable={false} forwardsClickable={isForwardsPossible()}
                                onBackwards={() => {}} onForwards={handleForwards}
                                backwardsText={""} forwardsText={locale.msgs.CONTINUE}
                                forwardsLoadState={LoadState.NONE} />
            </div>
        </div>
    );
}

function FamOrNanny(props) {
    const locale = useContext(LocaleContext);


    // RENDER:

    return(
        <div id="fam_or_nanny" className="margin_to_header">
            <h1 className="head">{locale.msgs.WHAT_ARE_YOU_LOOKING_FOR}</h1>
            <div className="text">{locale.msgs.WHAT_ARE_YOU_LOOKING_FOR_DESCR}</div>

            <div id="radio_one">
                <RadioCheckButton type="radio" text={locale.msgs.USER_TYPE_NANNY} id="0" name="fam_nan"
                        checked={props.userType === UserType.NANNY} onChange={() => props.onUserTypeChange(UserType.NANNY)}/>
            </div>
            
            <div id="radio_two">
                <RadioCheckButton type="radio" text={locale.msgs.USER_TYPE_FAMILY} id="1" name="fam_nan"
                        checked={props.userType === UserType.FAMILY} onChange={() => props.onUserTypeChange(UserType.FAMILY)}/>
            </div>

        </div>
    );
}
